<template>
<span class="EditOtaFile">
    <el-button class="EditOtaFileBtn" :type="btnType" @click="handleDialogShow">
        <slot name='btnText'>{{btnText}}</slot>
    </el-button>
    <el-dialog class="EditOtaFileDialog" :title="btnText" width="500px" @close="handleDialogClose"
        :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false">
        <div class="dialog-container">
            <!-- <div class="form-item required">
                <div class="key">{{$t(/*版本号*/'file.version')}}：</div>
                <div class="value">
                    <el-input v-model="form.version" :placeholder="$t(/*请输入*/'c.input') + $t(/*版本号*/'file.version')"/>
                </div>
            </div> -->
            <div class="form-item required afs">
                <div class="key">{{$t(/*上传文件*/'file.upload')}}：</div>
                <div class="value">
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :on-success="handleUploadSuccess"
                        :on-remove="handleUploadRemove"
                        :on-error="handleUploadError"
                        :multiple="false"
                        :file-list="fileList">
                        <el-button type="primary">{{$t(/*选择文件*/'file.select')}}</el-button>
                    </el-upload>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleDialogClose">{{$t(/*取消*/'c.cancel')}}</el-button>
            <el-button @click="handleDialogConfirm" type="primary">{{$t(/*确定*/'c.confirm')}}</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
import Core from '../../../core'

export default {
    name: "EditOtaFile",
    components: {},
    props: {
        btnType: { type: String, default: 'primary', },
        btnText: { type: String, },

        taskId: { type: [String, Number] },
        detail: { type: Object, default: () => {return {}} },
        version: { type: String, },
    },
    data() {
        return {
            loading: false,
            dialogShow: false,

            uploadUrl: Core.Const.NET.OTA_FILE_UPLOAD_END_POINT,
            form: {
                version: "",
                name: '',
                path: '',
                hash: '',
                size: '',
            },
            fileList: [],
        }
    },
    methods: {
        handleDialogShow() {
            if (this.detail.id) {
                for (const key in this.form) {
                    this.form[key] = this.detail[key] || ''
                }
            }
            console.log('this.form:', this.form)
            this.dialogShow = true
        },
        handleDialogClose() {
            this.dialogShow = false
            for (const key in this.form) {
                this.form[key] = ''
            }
            this.fileList = [];
        },
        handleDialogConfirm() {
            const f = Core.Util.deepCopy(this.form)
            console.log('handleDialogConfirm',' f:', f)
            if (!f.name) {
                return this.$message.warning(this.$t(/*请输入*/'c.input')+this.$t(/*版本号*/'file.version'));
            }

            this.loading = true
            Core.Api.OtaTask.fileCreate({
                id: this.detail.id ? this.detail.id : 0,
                task_id: this.taskId,
                ...f,
                version: this.version,
            }).then(() => {
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                this.$emit('change')
                this.handleDialogClose();
            }).catch(err => {
                console.log('handleDialogConfirm err:', err)
                this.loading = false
            })
        },

        // 文件上传
        handleUploadSuccess(response, file) {
            console.log('handleUploadSuccess response:', response, 'file:', file)
            if (response && response.code === 0) {
                let data = response.data || {}
                this.form.name = file.name;
                this.form.path = "ota/" + data.name;
                this.form.hash = data.hash;
                this.form.size = data.size;
            } else {
                this.$message.warning(this.$t(/*上传失败*/'c.upload_failure'));
            }
            this.fileList = [file]
        },
        handleUploadError() {
            this.$message.warning(this.$t(/*上传失败*/'c.upload_failure'));
        },
        handleUploadRemove(file, fileList) {
            let temp = this.form.version
            for (const key in this.form) {
                this.form[key] = ''
            }
            this.form.version = temp
            this.fileList = [];
        },
    }

}
</script>

<style scoped lang="scss">
// .EditOtaFile {}
</style>